<template>
  <div class="col-xl-3 xl-50 col-sm-6 box-col-6">
    <div class="card features-faq product-box">
      <div class="faq-image product-img"><img class="img-fluid" src="@/assets/images/faq/3.jpg" alt="">
        <div class="product-hover">
          <ul>
            <li><router-link to="/knowledgebase/detail"><i class="icon-link"></i></router-link></li>
            <li><router-link to="/knowledgebase/detail"><i class="icon-import"></i></router-link></li>
          </ul>
        </div>
      </div>
      <div class="card-body"><router-link to="/knowledgebase/detail">
          <h6>Ux Design</h6></router-link>
        <p>User Experience design (UX) is the design for machines and software, such as mobile devices, computers.</p>
      </div>
      <div class="card-footer"><span>May 22, 2023</span>
        <ul class="pull-right">
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="col-xl-3 xl-50 col-sm-6 box-col-6">
    <div class="card features-faq product-box">
      <div class="faq-image product-img"><img class="img-fluid" src="@/assets/images/faq/4.jpg" alt="">
        <div class="product-hover">
          <ul>
            <li><router-link to="/knowledgebase/detail"><i class="icon-link"></i></router-link></li>
            <li><router-link to="/knowledgebase/detail"><i class="icon-import"></i></router-link></li>
          </ul>
        </div>
      </div>
      <div class="card-body"><router-link to="/knowledgebase/detail">
          <h6>Php Developer</h6></router-link>
        <p>This course is designed to start you on a path toward future studies in web development and design.</p>
      </div>
      <div class="card-footer"><span>Jun 29, 2023</span>
        <ul class="pull-right">
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star-half-o font-primary"></i></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="col-xl-3 xl-50 col-sm-6 box-col-6">
    <div class="card features-faq product-box">
      <div class="faq-image product-img"><img class="img-fluid" src="@/assets/images/faq/1.jpg" alt="">
        <div class="product-hover">
          <ul>
            <li><router-link to="/knowledgebase/detail"><i class="icon-link"></i></router-link></li>
            <li><router-link to="/knowledgebase/detail"><i class="icon-import"></i></router-link></li>
          </ul>
        </div>
      </div>
      <div class="card-body"><router-link to="/knowledgebase/detail">
          <h6>Graphic Design</h6></router-link>
        <p>Graphic design is a craft where professionals create visual content to communicate messages thought messanger.</p>
      </div>
      <div class="card-footer"><span>July 20, 2023</span>
        <ul class="pull-right">
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star-o font-primary"></i></li>
          <li><i class="fa fa-star-o font-primary"></i></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="col-xl-3 xl-50 col-sm-6 box-col-6">
    <div class="card features-faq product-box">
      <div class="faq-image product-img"><img class="img-fluid" src="@/assets/images/faq/2.jpg" alt="">
        <div class="product-hover">
          <ul>
            <li><router-link to="/knowledgebase/detail"><i class="icon-link"></i></router-link></li>
            <li><router-link to="/knowledgebase/detail"><i class="icon-import"></i></router-link></li>
          </ul>
        </div>
      </div>
      <div class="card-body"><router-link to="/knowledgebase/detail">
          <h6>Development</h6></router-link>
        <p>A content developer is typically a marketing professional who creates digital and physical content including blog posts,</p>
      </div>
      <div class="card-footer"><span>Dec 15, 2023</span>
        <ul class="pull-right">
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star font-primary"></i></li>
          <li><i class="fa fa-star-o font-primary"></i></li>
        </ul>
      </div>
    </div>
  </div>
</template>